import type { ReactNode } from 'react';
import ReactDOM from 'react-dom/client';

export const render = (node: ReactNode): void => {
    const div = document.createElement('div');
    div.setAttribute('id', 'app');
    globalThis.document.body.append(div);

    ReactDOM.createRoot(div).render(node);
};
